function getFormatDate(date, format) {
  var safeDate = typeof date === 'string' ? date : String(date);
  var _date = new Date(safeDate);

  if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
  format = format.replace(/YYYY/g, _date.getFullYear());
  format = format.replace(/MMM/g, (['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][_date.getMonth()]));
  format = format.replace(/MM/g, ('0' + (_date.getMonth() + 1)).slice(-2));
  format = format.replace(/DD/g, ('0' + _date.getDate()).slice(-2));
  format = format.replace(/hh/g, ('0' + _date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + _date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + _date.getSeconds()).slice(-2));
  if (format.match(/S/g)) {
    var milliSeconds = ('00' + _date.getMilliseconds()).slice(-3);
    var length = format.match(/S/g).length;
    for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
  }

  return format;
}

export default {
  bind: function (el, bindings, vnode) {
  },
  inserted: function (el, bindings) {
    el.innerText = getFormatDate(bindings.value, el.innerText);
  },
  update: function (el, bindings) {
  },
  componentUpdated: function(el, bindings) {
  },
  unbind: function (el) {

  }
}


// WEBPACK FOOTER //
// ./src/plugins/dateFormat/directive.js